/*
session-management.controller.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/controllers/session-management.controller',[
    'angular',
    '../module',
    '../services/login.service',
    '../services/activitytracker.service'
], function (angular, module) {
    'use strict';

    module.controller('SessionManagementCtrl', [
        '$window',
        'loginService',
        'activityTrackerService',
        function ($window, loginService, activityTrackerService) {
            var redirectFunction = function () {
                loginService.invalidate();
                $window.location = '/login?message=440';
            };

            angular.element(document).on('click', function () {
                if (activityTrackerService.validateLastActivityTime()) {
                    if (loginService.isOtherUserLoggedInToAnotherTab()) {
                        redirectFunction();
                    }
                    else {
                        activityTrackerService.registerActivity();
                    }
                }
            });

            if (activityTrackerService.validateLastActivityTime()) {
                activityTrackerService.registerActivity();
            }

        }
    ]);

    return module;
});
